
import useColor from '~/composable/useColor';

export default {
  props: {
    article: {
      type: Object,
      default: () => {
        return {
          title: 'title',
          description: 'description',
          image: 'require(\'~/assets/images/phone-0.jpg\')',
          link: '',
          backgroundColor: 'lightblue light 1'
        }
      }
    }
  },
  setup() {
    const { getBackground } = useColor()
    return {
      getBackground
    }
  }
}
